import Fade from 'react-reveal/Fade';

export default function Footer() {
    return (
        <div id="Footer">
            <div className="main">
                <p className="a"><Fade top><div>Front-End Development, Softare Engineering, UI/UX, Branding, Game Development</div></Fade></p>
                <p className="b"><Fade top><div>jy9726@rit.edu<br></br>+1 (607) 262-2344</div></Fade></p>
                <p className="c"><Fade top><div>Ithaca, NY<br></br>Rochester, NY</div></Fade></p>
            </div>
            <div className="bottom">
                <p><Fade top><div>Designed and developed by Jacob Yoon. © 2022</div></Fade></p>
                <div className="links"><Fade top><div>
                    <a href="mailto:jy9726@rit.edu">Email</a>
                    <a href="https://www.linkedin.com/in/jaacobyoon/" target="_blank">LinkedIn</a>
                </div></Fade></div>
            </div>
        </div>
    )
}